import React from 'react';
import { VStack } from '~/components/gluestack/vstack';
import { Heading } from '~/components/gluestack/heading';
import { Card } from '~/components/gluestack/card';

interface ProfileSectionProps {
  title?: string;
  children: React.ReactNode;
  noCard?: boolean;
  className?: string;
}

export function ProfileSection({ title, children, noCard = false, className }: ProfileSectionProps) {
  return (
    <VStack className={`gap-2 ${className || ''}`}>
      {title && (
        <Heading size="xs" className="mt-2 text-typography-400">
          {title.toUpperCase()}
        </Heading>
      )}
      {noCard ? (
        children
      ) : (
        <Card size="md" className="gap-4">
          {children}
        </Card>
      )}
    </VStack>
  );
} 